import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TopicOverviewConverter extends CmsConverterService<TopicOverviewData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      background: formData.st_backgroundcolor?.value?.identifier ?? '',
      items: formData.st_items ?? defaultFSCatalog
    }
  }
}

export const TOPIC_OVERVIEW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CmsComponent>>('TopicOverviewConverter')

export interface TopicOverviewData extends ConvertedComponentData {
  headline: TextInput;
  background: string;
  items: FsCatalog;
}
